import styled from 'styled-components';
import { Link } from '@reach/router';

export const PlainLink = styled.a`
  color: ${props => props.theme.link.primaryColor.toHex()};
  :hover {
    text-decoration: none;
    color: ${props => props.theme.link.primaryColor.darken(0.2).toHex()};
  }
  transition: all 0.1s ease;
`;

export default PlainLink.withComponent(Link);
